module.exports = __webpack_public_path__ + "img/setmeal.d7a89e8c.svg";